import React from "react";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import { PasoForm } from "./PasoForm";
import { api_host } from "../../../../common/globals/constants";
import { toast } from "react-toastify";
import { Alert } from "@mui/material";
import { withTranslation } from 'react-i18next';

export const ModalUmbralPasos = withTranslation()(function ModalUmbralPasos({
    objetivo,
    updatePasosSuccess,
    open,
    onClose,
    t,
}) {
    const [isSendingData, setIsSendingData] = React.useState(false);
    const { pasos, objetivo: nombre, has_differences, reseteable_flashboard_config } = objetivo;
    const [pasosConfig, setPasosConfig] = React.useState(pasos);
    const [isResetLoading, setIsResetLoading] = React.useState(false);

    async function handleSubmit(event) {
        event.preventDefault();
        setIsSendingData(true);
        try {
            let umbrales = event.target.elements.umbral;
            let checkVisibilidad = event.target.elements.checkVisibilidad;
            let order = event.target.elements.order;
            const updatedFlashBoardData = {};
            if (!umbrales.length) {
                umbrales = [umbrales];
                checkVisibilidad = [checkVisibilidad];
                order = [order];
            }
            for (let i = 0; i < order.length; i++) {
                updatedFlashBoardData[order[i].value] = {
                    nombre: pasosConfig[order[i].value].nombre,
                    umbral: umbrales[i].value,
                    visible: checkVisibilidad[i].checked,
                };
            }

            const token = sessionStorage.getItem("key");
            const response = await toast.promise(
                fetch(
                    `${api_host}/reporte/online/indicadores/updatePanelExtraFlashboardObjetivo/`,
                    {
                        method: "PATCH",
                        body: JSON.stringify({
                            token,
                            datos_objetivo: {
                                objetivo_id: objetivo.objetivo_id,
                                link: objetivo.link,
                                visible: objetivo.visible,
                                umbral_rendimiento: objetivo.umbral_rendimiento,
                                pasos: updatedFlashBoardData,
                            },
                        }),
                        headers: { "Content-Type": "application/json" },
                    }
                ),
                {
                    pending: t('flashboard.toast.pending'),
                }
            );
            if (!response.ok) {
                throw new Error(t('flashboard.toast.errorSave'));
            }
            toast.success(t('flashboard.toast.saveSuccess'));
            updatePasosSuccess(objetivo.objetivo_id, updatedFlashBoardData);
        } catch (err) {
            toast.error(err.message ?? t('flashboard.toast.retryLater'));
        } finally {
            setIsSendingData(false);
        }
    }

    async function resetForm() {
        setIsResetLoading(true);
        await new Promise(resolve => setTimeout(resolve, 2000));
        setIsResetLoading(false);
        setPasosConfig(reseteable_flashboard_config);
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle disableTypography={true}>
                <Typography variant="h4">
                    {t('flashboard.modal.title', { nombre })}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {has_differences && (
                    <Alert severity="warning" style={{ marginBottom: 20 }}>
                        <Typography>
                            {t('flashboard.modal.alert.part1')}
                            <Button size='small' onClick={resetForm}>{t('flashboard.modal.updateButton')}</Button>
                            {t('flashboard.modal.alert.part2')}
                        </Typography>
                    </Alert>
                )}
                {isResetLoading && <LinearProgress />}
                {isSendingData && <LinearProgress />}
                <form onSubmit={handleSubmit}>
                    <Table className="at-custom-form-table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('flashboard.table.header.step')}</TableCell>
                                <TableCell>{t('flashboard.table.header.responseThreshold')}</TableCell>
                                <TableCell>{t('flashboard.table.header.visibility')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.keys(pasosConfig).map((key, index) => (
                                <PasoForm
                                    key={pasosConfig[key]["nombre"]}
                                    paso={pasosConfig[key]["nombre"]}
                                    defaultValueUmbral={pasosConfig[key]["umbral"]}
                                    visible={pasosConfig[key]["visible"]}
                                    order={key}
                                />
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell
                                    colSpan={4}
                                    align="right"
                                    style={{ border: "none" }}
                                >
                                    <Button
                                        type="submit"
                                        color="primary"
                                        variant="contained"
                                        disabled={isSendingData}
                                    >
                                        {t('flashboard.button.save')}
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </form>
            </DialogContent>
        </Dialog>
    );
});
